"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserBalance = void 0;
class UserBalance {
}
exports.UserBalance = UserBalance;
//# sourceMappingURL=UserBalance.js.map